import { useParams, Link } from "react-router-dom";
import { articles } from "@/mocks/data";
import SEOHead from "@/components/base/SEOHead";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/base/Breadcrumb";

export default function ArticlePage() {
  const { slug } = useParams<{ slug: string }>();
  const article = articles.find((a) => a.slug === slug);

  if (!article) {
    return (
      <>
        <SEOHead title="文章未找到" description="" keywords="" />
        <div className="min-h-screen bg-background-50">
          <Navbar />
          <main className="pt-20 pb-16">
            <div className="max-w-3xl mx-auto px-4 md:px-6 text-center py-20">
              <h1 className="text-2xl font-heading font-semibold text-foreground-950">文章未找到</h1>
            </div>
          </main>
          <Footer />
        </div>
      </>
    );
  }

  const articleSchema = {
    "@context": "https://schema.org",
    "@type": "Article",
    headline: article.title,
    description: article.excerpt,
    image: article.image,
    datePublished: article.date,
    author: {
      "@type": "Organization",
      name: "私享观影指南",
    },
    publisher: {
      "@type": "Organization",
      name: "私享观影指南",
    },
    mainEntityOfPage: {
      "@type": "WebPage",
      "@id": `https://jkenglish.cn/article/${article.slug}`,
    },
  };

  return (
    <>
      <SEOHead
        title={`${article.title} | 私享观影指南`}
        description={article.excerpt}
        keywords={`成人影院,${article.categoryName},${article.title},私密观影`}
        ogType="article"
        ogImage={article.image}
        schemaJson={articleSchema}
      />
      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20 pb-16">
          <article className="max-w-3xl mx-auto px-4 md:px-6">
            <Breadcrumb
              items={[
                { label: "首页", href: "/" },
                {
                  label: article.categoryName,
                  href: `/category/${article.category}`,
                },
                { label: article.title },
              ]}
            />

            <header className="mt-8 mb-10">
              <div className="flex items-center gap-3 mb-4">
                <Link
                  to={`/category/${article.category}`}
                  className="px-3 py-1 bg-primary-100 text-primary-700 text-xs font-medium rounded-full whitespace-nowrap hover:bg-primary-200 transition-colors cursor-pointer"
                >
                  {article.categoryName}
                </Link>
                <span className="text-xs text-foreground-400">{article.date}</span>
                <span className="text-xs text-foreground-400">{article.readTime}</span>
              </div>
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                {article.title}
              </h1>
            </header>

            <div className="mb-10 rounded-lg overflow-hidden">
              <img
                src={article.image}
                alt={article.title}
                className="w-full h-auto object-cover"
              />
            </div>

            <div
              className="article-content"
              dangerouslySetInnerHTML={{ __html: article.content }}
            ></div>

            <div className="mt-16 pt-8 border-t border-background-200/70">
              <Link
                to={`/category/${article.category}`}
                className="inline-flex items-center gap-2 text-sm text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
              >
                <i className="ri-arrow-left-line w-4 h-4 flex items-center justify-center"></i>
                返回{article.categoryName}
              </Link>
            </div>
          </article>
        </main>
        <Footer />
      </div>
    </>
  );
}